import firebase from "../../firebase";

export default function({ officeId, usersId }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "messagingAdmin",
        funcName: "reorderUsers",
        data: {
            officeId,
            usersId
        }
    });
}
